import React, { memo, useEffect, useState } from "react";
import { Row } from "reactstrap";

import CurrentQuestion from "components/FullTest/CurrentQuestion";

const Question = memo(function Question({ question, props_data }) {
  const [showQuestion, setShowQuestion] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowQuestion(true);
    }, 100);
  }, []);
  // console.log(showQuestion, "showQuestion");
  // console.log(question, "question");
  return (
    <Row className="unselectable">
      {showQuestion && (
        <CurrentQuestion
          subcategoryId={question?.subcategory_id}
          props_data={props_data}
        />
      )}
    </Row>
  );
});

export default Question;
